


    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters } from 'vuex';

    import formatDate from '@/shared/filters/formatDate.filter.ts';
    import uppercase from '@/shared/filters/uppercase.filter.ts';
    import UtilsService from '@/core/services/utils.service';
    import Assets from '@/constants/assets.ts';
    import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
    import TextArea from '@/shared/components/text-area.component.vue';

    import { Note } from '@/manager/convocation/note.model';
import Modal, { ModalTitleColor } from '@/shared/components/Modal.component.vue';
import Btn, { BtnColor, BtnPredefinedStyle, BtnWidth } from '@/shared/components/btn.component.vue';
import { BudgetAlertLiteral } from '@/manager/budget/models/budget.model';
import FlatSelectorTextMultiple from '@/shared/components/FlatSelectorTextMultiple.component.vue';
import SelectTag from '@/shared/components/select.tag.component.vue';
import ClientService from '@/manager/client/client.service';

    @Component({
        components: {
            Icon,
            Btn,
            FlatSelectorTextMultiple,
            Modal,
            TextArea,
            SelectTag
        },
        computed: {
            ...mapGetters ({
                getProfile: 'getProfile',
                getConvocationNote: 'getConvocationNote',
                getParticipantNote: 'getParticipantNote',
                getParticipantNotes: 'getParticipantNotes'
            }),
        },
        methods: {
            ...mapActions({
                fetchEmployeeList: 'fetchEmployeeList',
            }),
            updateComment(commentId:any, comment:any) {
                this.$emit( 'note-item-update', commentId, comment );
            }
        },
        filters: {
            formatDate,
            uppercase,
        },
    })
    export default class NoteItemClient extends Vue {
        @Prop() private note!: any;
        @Prop() private noteId!: string;
        @Prop() private elementId!: string;
        @Prop() private element!: any;
        @Prop() private employeeId!: string;
        @Prop( { default: 'convocation' } ) private type!: string;

        private assets = Assets;
        private iconEnum = IconEnum;
        private getConvocationNote!: any;
        private getParticipantNote!: any;
        private getParticipantNotes!: any;
        private getProfile!: any;
        private updatingTime = 1000;
        private updateTimeout!: any;
        private utilsService = UtilsService;
        private btnWidth = BtnWidth;
        private btnColor = BtnColor;
        private budgetAlertLiteral = BudgetAlertLiteral;
        private btnPredefinedClass = BtnPredefinedStyle;
        private modalTitleColor = ModalTitleColor;
        private deleteBudgetModalOpened = false;
        private addObservationBudgetModalOpened = false;
        private modalNoteEmpty = false;
        private modalNote = "";
        private addCommentModalOpened = false;
        private modalCommentEmpty = false;
        private modalComment = "";
        private notifications = [];
        private employeeList = [];
        private fetchEmployeeList !: any;
        private employeeEmails = [];
        private isUpdated = false;


        @Watch('noteContent')
        public watchNoteContent(newVal: string, oldVal: string) {
            this.isUpdated = true;
        }

        public saveNote() {
            // clearTimeout( this.updateTimeout );
            // this.updateTimeout = setTimeout(() => {
            if ( this.note.note !== '' ) {
                this.$emit( 'note-item-update', this.note.id, this.note.note, this.element );
                this.isUpdated = false;
            }
            // }, this.updatingTime);
        }

        private created() {
            this.fetchEmployeeEmails();
        }

        private fetchEmployeeEmails() {
            let payload = {
                limit: 1000
            }
            this.$store.dispatch("fetchEmployeeList", payload).then((res) => {
            this.employeeList = res.results.map((e: any) => {
                return {
                name: e.user.fullName,
                email: e.user.email,
                id: e.user.id,
                };
            });
        });
        }

        private setIsPostponement(isPostponement:any, id:any) {
            // this.purchase.requestReturn = status;
            this.$emit( 'note-item-posponement-update', this.element, this.note.id, this.note.note, isPostponement);
        }

        private updateComment(commentId:any, comment:any) {
            const payload = {
                elementId: this.elementId,
                commentId: commentId,
                noteId: this.noteId,
                data: { comment: comment, employeeModified: this.employeeId, isEdited: true },
            };
            this.$store.dispatch("patchBudgetCommentNote", payload);
            this.$emit( 'comment-item-update', this.element );

            // this.$store.dispatch("patchBudgetCommentNote", payload).then((res: any) => {
            //     this.$emit( 'comment-note-item-delete' );
            // });
        }

        // private onError() {
        //     this.emitShowMessage(Constants.internalServerErrorMessage, true);
        // }
        // private onSucess() {
        //     this.emitShowMessage('Email envíado correctamente');
        // }

        // private sendNotificationsNoteEmail() {
        //     let data = {
        //         'employees': this.employeeEmails,
        //         'note': this.note
        //     }
        //     ClientService.sendNotificationsNote(data)
        //     // .then(this.onSucess, this.onError);
        // }

        private sendNotificationsNoteEmail(value: boolean) {
            this.addObservationBudgetModalOpened = value;

            let emails = this.employeeEmails.map((employee:any) => employee['email']);
            let data = {
                'sender': this.getProfile.fullName,
                'from': this.getProfile.email,
                'emails': emails,
                'id': this.note.id,
                'content': this.note.note,
                'date': this.note.created,
                'creator': (this.note.employee ? this.note.employee.user.firstName : 'Usuario desconocido')
            }
            ClientService.sendNotificationsNote(data)
            // .then(this.onSucess, this.onError);
        }

        private toggleBudgetObservationModalOpened(value: boolean) {
            // sendNotifications(note.id)
            
            this.addObservationBudgetModalOpened = value;
            // this.sendNotificationsNoteEmail();
        }

        private toggleCommentModalOpened(value: boolean) {
            this.addCommentModalOpened = value;
        }

        // get note() {
        //     let result;
        //     if ( this.type === 'convocation' ) {
        //         result = this.getConvocationNote( this.noteId );
        //     } else if ( this.type === 'participant' ) {
        //         result = this.getParticipantNote( this.noteId );
        //     } else if ( this.type !== 'convocation' && this.type !== 'participant' ) {
        //         const getter = this.type;
        //         result = this.$store.getters[getter]( this.noteId );
        //     }
        //     return result;
        // }
        

        get noteContent() {
            return this.note.note;
        }

        get modalNotePlaceholder() {
            let placeholder =
                "Comparte alguna observación con tus compañeros sobre esta alta...";
            if (this.modalNoteEmpty) {
                placeholder = "Este campo no puede estar vacío...";
            }
            return placeholder;
        }

        get modalCommentPlaceholder() {
            let placeholder =
                "Comparte algún comentario con tus compañeros sobre la nota de esta alta...";
            if (this.modalCommentEmpty) {
                placeholder = "Este campo no puede estar vacío...";
            }
            return placeholder;
        }

        private addComment(noteId:any) {
            if (this.modalComment.length === 0) {
            this.modalCommentEmpty = true;
            } else {
            this.addCommentModalOpened = false;
            // this.requestShowSpinner();
            this.$store
                .dispatch("newBudgetCommentNote", {
                    elementId: this.elementId,
                    noteId: noteId,
                    employee: { user: { id: this.employeeId } },
                    comment: this.modalComment,
                })
                .then((res) => {
                    if (this.type == 'budget' || this.type == 'purchase') {
                        this.$emit( 'comment-note-item-delete', this.element.id );
                    } else {
                        this.$emit( 'comment-note-item-delete', this.element.convocationId );
                    }
                    // this.resetModalNoteEmpty(true);
                    // this.fetchBudgetNotes(this.elementId);
                    // // this.changeSpinnerVisibility(false);
                    // this.refetchBudget(this.elementId);
                });
            }
        }

        private fetchBudgetNotes(budgetId:any) {
            // this.requestShowSpinner();
            this.$store
            .dispatch("fetchBudgetNotes", { id: budgetId })
            .then((res) => {
                this.$emit( 'comment-note-item-delete' );
                // this.changeSpinnerVisibility(false);
                // if (!this.yetOpenedCollapsableInfo) {
                // this.yetOpenedCollapsableInfo = true;
                // }
            });
        }

        private refetchBudget(budgetId:any) {
            this.$store.dispatch("fetchBudget", { id: budgetId });
        }

        private resetModalNoteEmpty(force: boolean) {
            if (force || this.modalNote === "") {
            this.modalNoteEmpty = false;
            this.modalNote = "";
            }
        }

        get me() {
            return (
                this.note.employee &&
                this.note.employee.user &&
                this.getProfile.id === this.note.employee.user.id
            );
        }

        get allMe() {
            return (
                this.note.employee &&
                this.note.employee.user &&
                this.getProfile.id === this.note.employee.user.id && (!this.note.noteComment || this.onlyMyComments(this.note.noteComment))
            );
        }

        private onlyMyComments(comments: any) {
            var onlyMyComments = true;
            comments.forEach((comment:any, index:any) => {
                if ((comment.employee.user.id != this.note.employee.user.id) || 
                comment.employeeModified && 
                (comment.employeeModified.user.id != this.note.employee.user.id)) {
                    return onlyMyComments = false;
                }
                // if (index == comments.length-1) {
                //     return onlyMyComments; 
                // }
            });
            return onlyMyComments;
        }

        private checkCommentUser(userId:any) {
            if (userId == this.employeeId) {
                return true;
            } else {
                return false;
            }
        }

        get avatar() {
            let avatar = this.assets.defaultAvatar;
            if (
                this.note.employee &&
                this.note.employee.user &&
                this.note.employee.user.avatar !== null
            ) {
                avatar = this.note.employee.user.avatar;
            }
            return avatar;
        }

        get notificationsOptions() {
            const options: { id: any; name: any; }[] = [];
            this.employeeList = this.fetchEmployeeList(({
                search: '',
                limit: -1,
            })).then(function(response:any) {
                // console.log(response);
                for (const employee in response.results) {
                    if (Number(employee) >= 0) {
                        options.push({
                            id: response.results[employee]['user']['id'],
                            name: response.results[employee]['user']['fullName'],
                        });
                        // console.log(options);
                    }
            }
            });

            // console.log(this.employeeList);
            
            return options;
        }

        private sendNotifications(id:any) {
            this.employeeList = this.fetchEmployeeList(({
                search: '',
                limit: -1,
            }));
        }

        private deleteCommentNote( commentId: string ) {
            const payload = {
                elementId: this.elementId,
                noteId: this.noteId,
                commentId,
            };
            this.$store.dispatch('removeBudgetCommentNote', payload)
                .then((res: any) => {
                    this.$emit( 'comment-note-item-delete' );
                });
        }


        private emitDelete() {
            if (this.type == 'budget') {
                this.$emit( 'note-budget-item-delete', this.note.id, this.element )
            } else if (this.type == 'purchase') {
                this.$emit( 'note-purchase-item-delete', this.note.id, this.element )
            }
            else {
                this.$emit( 'note-item-delete', this.note.id, this.element );
            }
        }

        private emitNote() {
            console.log(this.elementId);
            if (this.type == 'budget') {
                this.$emit( 'note-budget-item-new', this.elementId)
            } else if (this.type == 'purchase') {
                this.$emit( 'note-purchase-item-new', this.elementId)
            }
            else {
                this.$emit( 'note-item-new', this.elementId );
            }
        }
    }

